import { parseFlag } from 'lib/environment';

export const VERSION = process.env.REACT_APP__VERSION || '';
export const ENVIRONMENT = process.env.REACT_APP__ENVIRONMENT || 'development';
export const SENTRY_DSN = process.env.REACT_APP__SENTRY_DSN;
export const ROUTER_BASENAME = process.env.REACT_APP__ROUTER_BASENAME;
export const SELF_SERVICE_API_URL = process.env.REACT_APP__SELF_SERVICE_API_URL;
export const HOTELS_BASE_URL = process.env.REACT_APP__HOTELS_BASE_URL || 'https://www.qantas.com/hotels';

export const FLAG_GUEST_AMEND_ENABLED = parseFlag(process.env.REACT_APP__FLAG_GUEST_AMEND_ENABLED);
export const FLAG_LIVE_CHAT_ENABLED = parseFlag(process.env.REACT_APP__FLAG_LIVE_CHAT_ENABLED);
export const FLAG_CHANGE_DATE_REQUEST = parseFlag(process.env.REACT_APP__FLAG_CHANGE_DATE_REQUEST);
export const FLAG_CHANGE_DATE = parseFlag(process.env.REACT_APP__FLAG_CHANGE_DATE);
export const FLAG_APPLE_WALLET_PASSES_ENABLED = parseFlag(process.env.REACT_APP__FLAG_APPLE_WALLET_PASSES_ENABLED);

export const SALESFORCE_LIVECHAT_BUTTON_URL = process.env.REACT_APP__SALESFORCE_LIVECHAT_BUTTON_URL;
export const SALESFORCE_LIVECHAT_PROFILE_NAME = process.env.REACT_APP__SALESFORCE_LIVECHAT_PROFILE_NAME;
export const SALESFORCE_LIVECHAT_DEPLOYMENT_ID = process.env.REACT_APP__SALESFORCE_LIVECHAT_DEPLOYMENT_ID;
export const SALESFORCE_LIVECHAT_BUTTON_ID = process.env.REACT_APP__SALESFORCE_LIVECHAT_BUTTON_ID;
export const SALESFORCE_LIVECHAT_AGENT_DEV_NAME = process.env.REACT_APP__SALESFORCE_LIVECHAT_AGENT_DEV_NAME;

export const OPTIMIZELY_CLIENT_SDK_KEY = process.env.REACT_APP__OPTIMIZELY_CLIENT_SDK_KEY || '';
export const OPTIMIZELY_LOG_LEVEL = process.env.REACT_APP__OPTIMIZELY_LOG_LEVEL || 'error';

export const RELATIONSHIP_BASE_URL = process.env.REACT_APP__RELATIONSHIP_BASE_URL || '/';
